var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Pie',{attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"width":300,"height":300}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }